import 'react-app-polyfill/stable';

// base
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.less';

// packages
import { ConfigProvider } from 'antd';
import ko_KR from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';

// modules
import { saga } from './modules';

import App from './App';
import store, { sagaMiddleware } from 'modules/store';

sagaMiddleware.run(saga);

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={ko_KR}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);
